import moment from 'moment';
import {GetAllowedUsage_allowedUsage} from '../../views/dashboard/__generated__/GetAllowedUsage';
import {notEmpty} from './utils';
import {TimeSelectionOptionWithAllowedUsage} from '../../views/dashboard/dashboard.component';

export interface TimeSelectionOption extends TimeSelection {
  title: string;
}

export interface TimeSelection {
  gte: string;
  lt: string;
}

export interface SpecificTimeSelection {
  title: string;
  gte: string;
  lt: string | null;
}

export function getTimeSelectionOptions(
  tenantCreateDate: moment.Moment,
  now: moment.Moment,
): TimeSelectionOption[] {
  const timeSelectionOptions: TimeSelectionOption[] = [];

  let lookup = now.startOf('month');
  while (lookup > tenantCreateDate.clone().subtract(1, 'month')) {
    timeSelectionOptions.push({
      title: lookup.format('MMM YYYY'),
      gte: lookup.format('YYYY-MM-DDTHH:mm:ss'),
      lt: lookup.clone().add(1, 'month').format('YYYY-MM-DDTHH:mm:ss'),
    });
    lookup = lookup.subtract(1, 'month');
  }
  if (timeSelectionOptions[0]) {
    timeSelectionOptions[0].title = $localize`This month`;
  }
  if (timeSelectionOptions[1]) {
    timeSelectionOptions[1].title = $localize`Last month`;
  }
  return timeSelectionOptions;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function mapTimeSelection(filter: any): TimeSelection {
  if (filter === null) {
    return {
      gte: moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
      lt: moment().startOf('month').add(1, 'month').format('YYYY-MM-DDTHH:mm:ss'),
    };
  }
  return {
    gte: filter.gte,
    lt: filter.lt,
  };
}

export function getSpecificTimeSelection(): SpecificTimeSelection[] {
  const specificTimeSelections: SpecificTimeSelection[] = [];

  specificTimeSelections.push(
    {
      title: $localize`Today`,
      gte: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Yesterday`,
      gte: moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    },
    {
      title: $localize`This month`,
      gte: moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last month`,
      gte: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
      lt: moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
    },
    {
      title: $localize`This week`,
      gte: moment().startOf('isoWeek').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last 14 days`,
      gte: moment().subtract(14, 'day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last 30 days`,
      gte: moment().subtract(30, 'day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last 90 days`,
      gte: moment().subtract(90, 'day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last 180 days`,
      gte: moment().subtract(180, 'day').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`This year`,
      gte: moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss'),
      lt: null,
    },
    {
      title: $localize`Last year`,
      gte: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DDTHH:mm:ss'),
      lt: moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss'),
    },
  );
  return specificTimeSelections;
}

export function mapMonthSelection(
  allowedUsage: GetAllowedUsage_allowedUsage[],
): TimeSelectionOptionWithAllowedUsage[] {
  return allowedUsage.filter(notEmpty).map((a, index) => {
    const m = moment(a.month);

    let title = m.format('MMM YYYY');
    if (index === 0) {
      title = $localize`This month`;
    } else if (index === 1) {
      title = $localize`Last month`;
    }

    const lookup = m.startOf('month');
    return {
      title,
      allowedUsage: a.totalViews,
      gte: lookup.format('YYYY-MM-DDTHH:mm:ss'),
      lt: lookup.clone().add(1, 'month').format('YYYY-MM-DDTHH:mm:ss'),
      billingType: a.billingType,
    };
  });
}
